__webpack_require__.p = "/AdvancedMpkEditor/";